import {
    apiRequest,
    penilaianUpdate
} from "../../../../../services/adapters/kepegawaian/penilaianService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", penilaianUpdate, {
            body: query
        }, true)
    }

}

export default UpdateRepository